module.exports = __webpack_public_path__ + "img/cupra-logo.962fae45.svg";